import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type BUDGET_TYPE} from 'web-app/react/abstract-bugdet/constants';

const domain = 'MODALS/ABSTRACT_BUDGET';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (institutionId: string, type: BUDGET_TYPE, startYear?: string) => ({institutionId, type, startYear}),
);
export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
